import QuoteRequests from '@pages/QuoteRequestsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/quoteRequests')({
  component: QuoteRequests,
});
